/** Datadog names for the product_media 3D viewer, emitted from the browser.
 *
 * Keep values in lockstep with `App\Support\ProductMedia\ProductMedia3dMetric` and
 * `App\Support\ProductMedia\ProductMedia3dViewerOutcome` (PHP). No shared package carries these —
 * the PHP enums are where the Datadog application reads the canonical names, this module is where
 * the client emits them.
 */

export const PRODUCT_MEDIA_3D_METRIC = {
	// Datadog derives this one from the numeric `load_duration_ms` log field. The client never emits
	// it as a `metric` value.
	viewerLoadDurationMs: 'rp.webstore.product_media.3d.viewer.load_duration_ms',
	viewerLoadFailed: 'rp.webstore.product_media.3d.viewer.load_failed',
	viewerLoaded: 'rp.webstore.product_media.3d.viewer.loaded',
	viewerRenderFailed: 'rp.webstore.product_media.3d.viewer.render_failed',
};

export const PRODUCT_MEDIA_3D_VIEWER_OUTCOME = {
	loadFailed: 'load_failed',
	loaded: 'loaded',
	renderFailed: 'render_failed',
};

export const PRODUCT_MEDIA_3D_VIEWER_ERROR_TYPE = {
	glbLoadFailed: 'glb_load_failed',
	glbRenderFailed: 'glb_render_failed',
};
